module.exports = __webpack_public_path__ + "img/Ello.0054e08b.png";